module.exports = __webpack_public_path__ + "img/explain-img.39f74b97.jpg";